import ExpenseCategory from "../expense-category";


export class ExpenseCategoryAccessControl {

    private expenseCategory : ExpenseCategory

    constructor(expenseCategory:ExpenseCategory) {
        this.expenseCategory = expenseCategory
    }

    get canApprove():boolean {

        if (gd.user.acl.isManager) return true

        return false
    }

    get canReimburse():boolean {

        if (gd.user.acl.isManager) return true

        return false
    }


}
